import React from "react";
import Box from "@mui/material/Box";

import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import { HashLink } from "react-router-hash-link";
import AnimationOutlinedIcon from "@mui/icons-material/AnimationOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import { useTranslation } from "react-i18next";

const AdminUsersPartials = ({ users }) => {
  const { t, i18n } = useTranslation();
  console.log("users", users);
  return (
    <div>
      {users?.map((user, idx) => {
        return (
          <Box
            sx={{
              pt: 1,
            }}
          >
            <Box sx={{ pt: 1 }}>
              <Box className="">
                <PersonOutlinedIcon
                  sx={{ position: "relative", top: "+6px" }}
                />
                &nbsp;
                <span className="pink_link">
                  <HashLink to={"/admin/user/" + user.id}>
                    {user.firstname} {user.lastname}
                  </HashLink>
                </span>
                <span style={{ marginLeft: "4px" }}>
                  {user.position && user.position === "admin" ? (
                    <span style={{ color: "#00897b", fontWeight: 600 }}>
                      <AnimationOutlinedIcon
                        sx={{
                          position: "relative",
                          top: "+3px",
                          fontSize: "15px",
                        }}
                      />{" "}
                      {t("Admin")}
                    </span>
                  ) : null}
                  {user.position && user.position === "manager" ? (
                    <span style={{ color: "#00897b", fontWeight: 600 }}>
                      <AssignmentIndOutlinedIcon
                        sx={{
                          position: "relative",
                          top: "+3px",
                          fontSize: "15px",
                        }}
                      />{" "}
                      {t("Manager")}
                    </span>
                  ) : null}
                </span>
                &nbsp; {t("Member Since")}:&nbsp;
                {user?.created &&
                  user?.created?.toDate().toLocaleDateString("fr-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}{" "}
                {user?.created &&
                  user?.created?.toDate().toLocaleTimeString("ko-KR")}
                &nbsp;/&nbsp;
                <span style={{}}>
                  {user?.purchases ? (
                    <ShoppingBagOutlinedIcon
                      sx={{
                        color: "gray",
                        position: "relative",
                        top: "+6px",
                      }}
                    />
                  ) : null}
                  {user.purchases
                    ? user.purchases?.length + t(" purchases")
                    : null}{" "}
                </span>
                &nbsp;&nbsp;
                {user.reviews && user?.reviews.length > 0 ? (
                  <RateReviewOutlinedIcon
                    sx={{
                      color: "gray",
                      position: "relative",
                      top: "+6px",
                    }}
                  />
                ) : null}
                &nbsp;
                {user.reviews && user?.reviews.length > 0
                  ? user.reviews?.length + "개의 후기"
                  : null}
                &nbsp;&nbsp;
                {user.address ? (
                  <ContactMailOutlinedIcon
                    sx={{
                      color: "#283593",
                      position: "relative",
                      top: "+6px",
                    }}
                  />
                ) : null}
              </Box>
            </Box>
          </Box>
        );
      })}
    </div>
  );
};

export default AdminUsersPartials;
